<template>
    <div class="modal-position-fixed" v-show="modalOpen">
        <div class="modal-dialog modal-dialog " role="document">
            <div class="modal-content">
                <div class="jv-modal-header">
                    <h3 class="jv-modal-title">{{title}}</h3>
                    <button type="button" class="close" @click.prevent="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                   
                </div>
                <div class="modal-footer">
                    <hr />
                    <slot name="buttons"></slot>
                </div> 
            </div> 
        </div>
    </div>
</template>
<script>
    export default {
        name: 'confirmation',
        props: {
            modalOpen: Boolean,
            title: String
        },
        methods: {
            close() {
                this.$emit("close");
            }
        }
    }
</script>
<style scoped>

    .modal-position-fixed {
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1050;
        width: 100%;
        height: 100%;
        overflow: hidden;
        outline: 0;
        display: flex;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        pointer-events: auto;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3rem;
        outline: 0;
        overflow: visible;
        width: calc(15vw + 500px);
        max-width: 100%;
    }

    .modal-dialog {
        max-width: 80%;
    }

    .modal-body {
        overflow: visible;
        position: relative;
        flex: 1 1 auto;
        padding: 1rem;
    }

    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 1rem;
        border-top: 1px solid #dee2e6;
        border-bottom-right-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
    }
</style>